











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import BaseCard from '@/components/BaseCard.vue'

@Component<BaseBlock>({
    components: {
        BaseCard
    }
})
export default class BaseBlock extends Vue {
    @Prop({type: Boolean, default: false})
    public noPadding!: boolean
}
